import styled from 'styled-components';

export const Container = styled.div`
  .titleWrapper {
    height: 117px;
  }

  .TitleContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 29px;
    @media only screen and (max-width: 767px) {
      margin-top: -25px;
      justify-content: center;
    }
  }

  p {
    color: var(--purple);
    text-align: justify;
    @media only screen and (max-width: 767px) {
      margin: 120px 0 0 0;
      justify-content: center;
      align-items: center;
    }
  }
`;

export const LinkModal = styled.a`
  text-decoration: underline;
  color: var(--purple) !important;
  width: 50px;
  height: auto;
  cursor: pointer;
  :hover {
    color: var(--orange);
  }
  padding-right: 5px;
`;

export const ModalContent = styled.div`
  height: 250px;
  width: 600px;
  padding: 0px 15px 30px 15px;
  text-align: center;
  p {
    padding-bottom: 10px;
  }
`;

export const FormWrapper = styled.div`
  width: 100%;
  Form {
    margin-top: 20px;
  }

  input {
    height: 40px;
  }
  .btn-wrapper {
    margin-top: 30px;
    display: flex;
    width: 100%;
    button {
      width: inherit;
    }

    .btn-cancelar {
      color: #757575;
      background-color: #fff;
      border: 1px solid #e8e8e8;
      margin-right: 20px;
    }
  }
`;
export const Title = styled.h1`
  font-family: Roboto Slab;
  font-style: normal;
  font-weight: bold;
  font-size: 45px;
  line-height: 59px;

  color: var(--orange);

  align-items: center;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    text-align: center;
  }
`;

export const ButtonsContainer = styled.h1`
  .buttonsInitial {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
    button {
      font-size: 0.9rem;
      border-radius: 17px 17px;
      display: flex;
      align-items: center;
      margin-right: 10px;
      transition: background 0.3s ease;
    }
    .csv {
      color: var(--white);
      border: 2px solid var(--purple);
      &:hover {
        background: var(--white);
        color: var(--purple);
      }
    }
    .pdf {
      color: var(--white);
      border: 2px solid var(--purple);
      &:hover {
        background: var(--white);
        color: var(--purple);
      }
  }
  @media only screen and (max-width: 868px) {
    margin-top: 90px;
  }

  @media only screen and (max-width: 768px) {
    margin-top: 20px;
  }

  @media only screen and (max-width: 767px) {
    margin-top: 150px;
  }

  @media only screen and (max-width: 530px) {
    margin-top: 205px;
  }
`;

export const FiltersContainer = styled.div`
  margin-bottom: 25px;
  display: flex;
  align-items: flex-start;
  @media only screen and (max-width: 767px) {
    margin-top: 100px;
  }

  .search {
    width: 100%;
    form {
      position: relative;
    }
    div {
      height: 40px;
      margin-top: -4px;
      input {
        font-size: 18px;
      }
    }
    .searchButton {
      position: absolute;
      right: 0px;
      top: 0;
      display: flex;
      align-items: center;
      transition: background 0.3s ease;

      &:hover: {
        background: red;
      }
    }
  }
  .buttonsContainer {
    display: flex;
    button {
      width: 120px;
      font-size: 0.9rem;
      border-radius: 17px 17px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 10px;
      transition: background 0.3s ease;
    }
    .clearFilters {
      width: 145px;
      border-radius: 5px;
      margin-left: 5px;
      font-size: 0.9rem;
      display: flex;
      align-items: center;
      transition: background 0.3s ease;
      color: black;
      background-color: var(--aside-background);

      &:hover {
        background: #9ea1a2;
      }
    }
  }
`;

export const Block = styled.div`
  .carta {
    align-items: left;
    color: var(--orange);
    background: transparent;
    justify-content: left;
    text-align: left;
  }
`;
